export const FORM_PAGE_MODE_PAGE = 0

export const FORM_PAGE_MODE_MODAL = 1
